import React, { useEffect, useRef } from "react";
import { Fab } from "@mui/material";

const CustomCircleButton = ({
  children,
  onClick,
  width,
  height,
  border,
  bShadow,
  bRadius,
  bgColor,
  color,
  hoverBgColor,
  hoverColor,
  hoverBorder,
  activeBgColor,
  activeColor,
  disabled,
  className,
  focusBtn,
  disabledColor,
}) => {
  const btnRef = useRef();

  useEffect(() => {
    focusBtn && btnRef.current.focus();
  }, [focusBtn]);

  return (
    <Fab
      className={className ? className : ""}
      disabled={disabled}
      onClick={onClick}
      aria-label='button'
      ref={btnRef}
      sx={{
        width: width,
        height: height,
        minWidth: width,
        minHeight: height,
        border: border ? border : "1.5px solid",
        borderColor: "black.main",
        borderRadius: bRadius,
        backgroundColor: bgColor,
        color: color,
        boxShadow: bShadow,
        zIndex: 1,
        "&.MuiButtonBase-root:hover": {
          backgroundColor: hoverBgColor,
          color: hoverColor,
          border: hoverBorder,
        },
        "&.MuiButtonBase-root:active": {
          boxShadow: "none",
          backgroundColor: activeBgColor,
          color: activeColor,
          border: hoverBorder,
        },
        "&.Mui-disabled": {
          backgroundColor: disabledColor
            ? disabledColor
            : "primaryDisabled.main",
          color: "blackDisabled.main",
          borderColor: "blackDisabled.main",
        },
      }}
    >
      {children}
    </Fab>
  );
};

export default CustomCircleButton;
